import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { NAV_LINKS, CONTACT } from "../data/content";
import { WhatsAppNavLink } from "./WhatsAppButton";
import InstagramLink from "./InstagramLink";
import logo from "../assets/logo.png";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative bg-primary text-primary-foreground mt-24">
      <div className="max-w-7xl mx-auto px-6 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5 mb-5">
            <span className="grid place-items-center w-12 h-12">
              <img src={logo} alt="Kalpavriksha logo" className="w-full h-full object-contain" data-testid="footer-logo-image" />
            </span>
            <span className="font-serif-display text-2xl">Kalpavriksha</span>
          </div>
          <p className="max-w-md text-primary-foreground/70 leading-relaxed">
            Crafting divine, grounded and timeless spaces. From concept to construction, we bring
            the wish-fulfilling spirit of the Kalpavriksha tree into every home we build.
          </p>
          <div className="flex items-center gap-3 mt-6">
            <InstagramLink
              className="inline-flex items-center justify-center w-11 h-11 rounded-full border border-primary-foreground/20 text-primary-foreground/80 hover:border-accent hover:text-accent transition-colors"
              iconSize={20}
            />
          </div>
        </div>

        <div>
          <h4 className="label-caps text-accent mb-5">Explore</h4>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-primary-foreground/70 hover:text-accent transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="label-caps text-accent mb-5">Reach Us</h4>
          <ul className="space-y-4 text-primary-foreground/70">
            <li className="flex items-start gap-3">
              <Phone size={18} className="mt-0.5 text-accent shrink-0" />
              <a href={CONTACT.telHref} className="hover:text-accent transition-colors">{CONTACT.phoneDisplay}</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={18} className="mt-0.5 text-accent shrink-0" />
              <a href={CONTACT.mailHref} className="hover:text-accent transition-colors break-all">{CONTACT.email}</a>
            </li>
            <li className="flex items-start gap-3">
              <WhatsAppNavLink className="inline-flex items-center gap-2 hover:text-[#25D366] transition-colors text-primary-foreground/70 border-0 bg-transparent p-0 font-normal" />
            </li>
            <li className="flex items-center gap-3">
              <InstagramLink
                showLabel
                className="inline-flex items-center gap-2 text-primary-foreground/70 hover:text-accent transition-colors border-0 bg-transparent p-0 w-auto h-auto font-normal"
                iconSize={18}
              />
            </li>
            <li className="flex items-start gap-3"><MapPin size={18} className="mt-0.5 text-accent shrink-0" /> {CONTACT.address}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-primary-foreground/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-primary-foreground/50">
          <p>© {new Date().getFullYear()} Kalpavriksha Interiors & Constructions. Led by Karthik Sharma.</p>
          <Link to="/admin/login" data-testid="admin-link" className="hover:text-accent transition-colors">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
